import request from "@/utils/request";
import { getUUID } from "@/utils/uuid";

// 换一批
const CHANGE = 1;
// 默认
const DEFAULT = 0;

function getVideosCommon(classification, change, pagination) {
  let type;
  if (!classification || classification === "热门") {
    type = "hot";
    classification = undefined;
  } else if (classification === "最新") {
    type = "isnew";
    classification = undefined;
  }
  const page = pagination.page + 1;
  return request({
    url: "/video/list",
    method: "get",
    params: {
      classification: classification,
      type: type,
      page,
      change,
      size: 10
    }
  });
}

export function getVideos(classification, pagination) {
  return getVideosCommon(classification, DEFAULT, pagination);
}

export function changeVideos(classification, pagination) {
  return getVideosCommon(classification, CHANGE, pagination);
}

export function getVideoDetail(id) {
  return request({
    url: `video/${id}/detail`,
    method: "get"
  });
}

export function getRelativeVideos(id, limit) {
  return request({
    url: `/video/${id}/relate/list`,
    method: "get",
    params: {
      limit: limit ? limit : 8
    }
  });
}

export function getVideoRelativeTags(id) {
  return request({
    url: `/video/${id}/relate/label`,
    method: "get"
  });
}

export function getAnnouncements() {
  return request({
    url: "/video/notice/list",
    method: "get"
  });
}

export function getHotTags() {
  return request({
    url: "/video/label/list",
    method: "get"
  });
}

export function searchVideo(name, labels) {
  return request({
    url: "/video/list",
    method: "get",
    params: {
      name,
      labels,
      change: 0,
      size: 100
    }
  });
}

export function getWatchTimes() {
  return request({
    url: "/video/view/info",
    method: "get",
    params: {
      uuid: getUUID()
    }
  });
}

export async function addWatchTimes(id, duration) {
  await request({
    url: `/my/video/${id}/watch/record`,
    method: "post",
    params: {
      id,
      watchDuration: duration
    }
  });
  return request({
    url: "/video/view/addCount",
    method: "get",
    params: {
      uuid: getUUID(),
      videoId: id
    }
  });
}

export function getWatchHistories() {
  return request({
    url: "/my/video/watch/record",
    method: "get"
  });
}

export function clearWatchHistories() {
  return request({
    url: "/my/video/watch/record/clear",
    method: "delete"
  });
}
